import * as localStorage from '../local-storage';

export class WindowLevel { // Class will be serialized in local storage, don't add methods.
    public ww: number;
    public wc: number;
    constructor(ww: number, wc: number) {
        this.ww = ww;
        this.wc = wc;
    }
}

export const PresetSoftTissue = new WindowLevel(400, 20);
export const DefaultWindowLevelPresets: {[name: string]: WindowLevel} = {
    'Abdomen (400, 40)': new WindowLevel(400, 40),
    'Bone (1600, 500)': new WindowLevel(1600, 500),
    'Brain (85, 30)': new WindowLevel(85, 30),
    'Breast (400, -50)': new WindowLevel(400, -50),
    'Dental (3000, 900)': new WindowLevel(3000, 900),
    'Liver (160, 50)': new WindowLevel(160, 50),
    'Lung (1600, -600)': new WindowLevel(1600, -600),
    'Metal (1, 2800)': new WindowLevel(1, 2800),
    'Neck (325, 65)': new WindowLevel(325, 65),
    'Pelvis (500, 0)': new WindowLevel(500, 0),
    'Prostate (210, -35)': new WindowLevel(210, -35),
    'Soft Tissue (350, 40)': new WindowLevel(350, 40),
    "CT Brainstem": new WindowLevel(82, 33),
    "CT Body": new WindowLevel(1350, -100),
    "CT Bone": new WindowLevel(2000, 300),
    "CT Lung": new WindowLevel(1600, -600),
    "CT Soft tissue": PresetSoftTissue,
    "MRI dix-w: 225/105": new WindowLevel(225, 105),
    "MRI dix-ip: 385/190": new WindowLevel(385, 190),
}

export function getWindowLevelPresets(): {[name: string]: WindowLevel} {
    let presets = localStorage.getWindowLevelPresets() || {};
    if( Object.keys(presets).length === 0) {
        presets = Object.assign(presets, DefaultWindowLevelPresets);
    }
    return presets;
}

export function setWindowLevelPreset(name: string, windowLevel: WindowLevel) {
    let presets = getWindowLevelPresets();
    presets[name] = windowLevel;
    localStorage.setWindowLevelPresets(presets);
}

export function deleteWindowLevelPreset(name: string) {
    let presets = getWindowLevelPresets();
    delete presets[name];
    localStorage.setWindowLevelPresets(presets);
}
